<app-dialog *ngIf="fileToUpload" titleText="Uploading ..."  type="confirm" [buttonText]="['Submit', 'Cancel']" (approveCallback)="handleSubmit()" (dismissCallback)="handleClose()">
  <div class="content">
    <img src="assets/document-large.svg"/>
    <div class="right-section">
      <div class="file-name ellipsis">{{fileToUpload.name}}</div>
      <div *ngIf="uploadFileError" class="upload-file-error">
        <img src="assets/error.svg"/>
        <span class="error">{{uploadFileError}}</span>
      </div>
    </div>
  </div>
</app-dialog>